import { FC, memo, useCallback, useEffect, useState } from 'react';

import { GameV1 } from '@/api/games';
import { ButtonHeart } from '@/components/buttons';
import { useCommonStore } from '@/store';

interface IHeartButtonProps extends Pick<GameV1, 'real'> {
  isFavorite: boolean;
}

export const HeartButton: FC<IHeartButtonProps> = memo(
  ({ real, isFavorite }) => {
    const addFavoriteGame = useCommonStore.use.addFavoriteGame();
    const removeFavoriteGame = useCommonStore.use.removeFavoriteGame();

    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(false);

    useEffect(() => setState(isFavorite), [isFavorite]);

    const handleHeartClick = useCallback(() => {
      setIsLoading(true);
      setState((s) => !s);
      if (state) {
        removeFavoriteGame(real).finally(() => {
          setIsLoading(false);
        });
      } else {
        addFavoriteGame(real).finally(() => {
          setIsLoading(false);
        });
      }
    }, [state, real, addFavoriteGame, removeFavoriteGame]);

    return (
      <ButtonHeart
        disabled={isLoading}
        active={state}
        top={4}
        right={4}
        width={24}
        height={24}
        onClick={handleHeartClick}
      />
    );
  }
);
